/**
 * Utilitários de apresentação para cards de resposta (PR-4).
 * Avatar com iniciais + cor determinística pelo nome/id do aluno.
 */

// Paleta saturada com bom contraste em texto branco (clara e escura).
const AVATAR_COLORS = ['#5B2DB8', '#1E9E6A', '#C23A6B', '#2D6CB8', '#B8632D', '#0E8A8A']

export function initials(name: string): string {
  const clean = (name || '').trim()
  if (!clean) return '?'
  const parts = clean.split(/\s+/).filter(Boolean)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

export function avatarColor(seed: string): string {
  let h = 0
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) | 0
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length]
}
